/* External dependencies */
import update from 'immutability-helper';

/* Local dependencies */
import { Order } from '../../../shared/types';
import { ListOrdersAction, ListOrdersActionTypes, ListOrdersFilter } from './types';

export interface ListOrdersState {
  error?: Error;
  loading?: boolean;
  orders: Order[];
  filter?: ListOrdersFilter;
  query: string;
  size: number;
  total: number;
  currentPage: number;
}

const size: number = 5;

export const initialListOrdersState: ListOrdersState = {
  orders: [],
  filter: {},
  loading: true,
  query: '',
  size,
  total: 0,
  currentPage: 1,
};

export default function listOrdersReducer(state = initialListOrdersState, action: ListOrdersAction) {
  switch (action.type) {
    case ListOrdersActionTypes.LIST_ORDERS_REQUEST:
      return update(state, {
        $unset: ['error'],
        loading: { $set: true },
        filter: { $set: action.filter },
        query: { $set: action.query },
        size: { $set: action.size },
        currentPage: { $set: action.currentPage },
      });

    case ListOrdersActionTypes.LIST_ORDERS_SUCCESS:
      return update(state, {
        loading: { $set: false },
        orders: { $set: action.orders },
        total: { $set: action.total },
      });

    case ListOrdersActionTypes.LIST_ORDERS_ERROR:
      return update(state, { $unset: ['error'], loading: { $set: false }, error: { $set: action.error } });

    case ListOrdersActionTypes.RESET_ERROR:
      return update(state, { $unset: ['error'] });

    case ListOrdersActionTypes.RESET_STATE:
      return initialListOrdersState;

    default:
      return state;
  }
}
